import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class SCTHApiLog
 *
 * @property {number} id
 */
export class SCTHApiLog extends Model {


}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'transaction_id',
    'correlation_id',
    'is_success',
    'api_type',
    'transaction_type',
    'requested_at',
    'request_body',
    'responded_at',
    'response_body'
)(SCTHApiLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/scth-api-log.model.js